module.exports = __webpack_public_path__ + "img/GPB.aee659d4.png";